module.exports = __webpack_public_path__ + "img/desktop-comingsoon.ad2be666.png";